import { Seo } from '@frontend/shared/web';

import { KpiGrid } from '../../components/dashboard/KpiGrid';
import { NoteClientCard } from '../../components/dashboard/NoteClientCard';
import { TimeSeriesChart } from '../../components/dashboard/TimeSeriesChart';
import { GlobalFilters } from '../../components/filters/GlobalFilters';
import { Header } from '../../components/layout/Header';
import { PerformanceExports } from '../../components/performance/PerformanceExports';
import { PunctualityHistogram } from '../../components/performance/PunctualityHistogram';
import { FEATURES } from '../../constants';

export const PerformanceRoute = () => (
  <>
    <Seo title="Performance — Portail extranet" />
    <Header title="Performance" subtitle="Analyse approfondie de la qualité de service sur la durée" />

    <div className="flex-1 overflow-y-auto">
      <div className="px-8 py-6 flex flex-col gap-5">
        <GlobalFilters />

        {FEATURES.dashboardNotes ? <NoteClientCard /> : null}

        <KpiGrid />

        <section className="grid gap-4 grid-cols-1 lg:grid-cols-2">
          <PunctualityHistogram />
          <TimeSeriesChart />
        </section>

        {FEATURES.performanceExports ? <PerformanceExports /> : null}
      </div>
    </div>
  </>
);
